module.exports = __webpack_public_path__ + "packs/media/images/home_7-1b27d68b873bfb6ba3516de2444b7985.jpg";